import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "flex justify-between items-center h-16" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "flex-shrink-0 flex items-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "hidden sm:-my-px sm:ml-6 sm:flex sm:space-x-8" }
const _hoisted_7 = {
  key: 0,
  class: "flex"
}
const _hoisted_8 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_9 = { href: "https://apps.apple.com/jp/app/りもく/id1626299401" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { href: "https://apps.apple.com/jp/app/りもく/id1626299401" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "hidden sm:ml-6 sm:flex sm:items-center" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "text-gray-500 text-sm font-medium" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "-mr-2 flex items-center sm:hidden" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open main menu", -1)
const _hoisted_19 = { class: "pt-4 pb-3 border-t border-gray-200" }
const _hoisted_20 = { class: "flex items-center px-4" }
const _hoisted_21 = { class: "flex-shrink-0" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "ml-3" }
const _hoisted_24 = { class: "text-base font-medium text-gray-800" }
const _hoisted_25 = { class: "text-sm font-medium text-gray-500" }
const _hoisted_26 = { class: "mt-3 space-y-1" }

import { computed, onBeforeMount, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from "@headlessui/vue";
import { MenuIcon, XIcon } from "@vue-hero-icons/outline";

// @Options({
//   components: {
//     Disclosure,
//     DisclosureButton,
//     DisclosurePanel,
//     Menu,
//     MenuButton,
//     MenuItem,
//     MenuItems,
//     MenuIcon,
//     XIcon,
//   },
// })
// export default class AppHeader extends Vue {


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

// import { Options, Vue } from "vue-class-component";

const store = useStore();
const router = useRouter();

const doSignout = () => {
  store.dispatch("signOut");
  router.replace("/signin");
};
// }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createBlock(_unref(Disclosure), {
    as: "nav",
    class: "bg-white border-b border-gray-200"
  }, {
    default: _withCtx(({ open }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h3", null, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: require('@/assets/images/logo_icon.png'),
                      class: "h-8"
                    }, null, 8, _hoisted_5)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: `/`,
                class: _normalizeClass(["text-gray-900 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium", { 'border-color-2': _ctx.$route.path == '/' }])
              }, {
                default: _withCtx(() => [
                  _createTextVNode("ホーム")
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_router_link, {
                to: `/search`,
                class: _normalizeClass(["text-gray-500 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium", { 'border-color-2': _ctx.$route.path == '/search' }])
              }, {
                default: _withCtx(() => [
                  _createTextVNode("検索")
                ]),
                _: 1
              }, 8, ["class"])
            ])
          ]),
          (_ctx.$store.state.customer?.email == 'rimoku@hasema-system.com')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("a", _hoisted_9, [
                    _createElementVNode("img", {
                      src: require('@/assets/images/appStore.png'),
                      target: "_blank",
                      alt: "",
                      class: "h-8"
                    }, null, 8, _hoisted_10)
                  ]),
                  _createElementVNode("a", _hoisted_11, [
                    _createElementVNode("img", {
                      src: require('@/assets/images/googleAppStore.png'),
                      target: "_blank",
                      alt: "",
                      class: "h-8"
                    }, null, 8, _hoisted_12)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_unref(Menu), {
              as: "div",
              class: "ml-6 relative"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_unref(MenuButton), { class: "max-w-xs bg-white flex items-center text-sm rounded-full z-10" }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        class: "h-8 w-8 mr-2 rounded-full",
                        src: 
                    _ctx.$store.state.customer?.selfie_image_url.replace('no-selfie.png', 'no-image.png') ??
                    require('@/assets/images/no-image.png')
                  ,
                        alt: ""
                      }, null, 8, _hoisted_14),
                      _createElementVNode("span", _hoisted_15, [
                        _createTextVNode(_toDisplayString(_ctx.$store.state.customer?.family_name) + " " + _toDisplayString(_ctx.$store.state.customer?.given_name), 1),
                        _hoisted_16
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_Transition, {
                  "enter-active-class": "transition ease-out duration-200",
                  "enter-from-class": "transform opacity-0 scale-95",
                  "enter-to-class": "transform opacity-100 scale-100",
                  "leave-active-class": "transition ease-in duration-75",
                  "leave-from-class": "transform opacity-100 scale-100",
                  "leave-to-class": "transform opacity-0 scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(MenuItems), { class: "z-50 origin-top-right absolute right-0 mt-2 w-64 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(MenuItem), null, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              to: `/me/profile`,
                              class: "block px-4 py-2 text-sm text-gray-700"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" プロフィール編集 ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(MenuItem), null, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              to: `/me/orders`,
                              class: "block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 宇宙祈願・宇宙供養申込履歴 ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(MenuItem), null, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              to: `/me/decedents`,
                              class: "block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 供養した故人 ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(MenuItem), null, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              href: "javascript:void(0)",
                              class: "block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100",
                              onClick: doSignout
                            }, " ログアウト ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_unref(DisclosureButton), { class: "bg-white inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100" }, {
              default: _withCtx(() => [
                _hoisted_18,
                (!open)
                  ? (_openBlock(), _createBlock(_component_fa, {
                      key: 0,
                      icon: "bars",
                      class: "block h-6 w-6",
                      "aria-hidden": "true"
                    }))
                  : (_openBlock(), _createBlock(_component_fa, {
                      key: 1,
                      icon: "times",
                      class: "block h-6 w-6",
                      "aria-hidden": "true"
                    }))
              ]),
              _: 2
            }, 1024)
          ])
        ])
      ]),
      _createVNode(_unref(DisclosurePanel), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("img", {
                  class: "h-10 w-10 rounded-full",
                  src: 
                _ctx.$store.state.customer?.selfie_image_url ??
                require('@/assets/images/no-selfie.png')
              ,
                  alt: ""
                }, null, 8, _hoisted_22)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$store.state.customer?.family_name) + " " + _toDisplayString(_ctx.$store.state.customer?.given_name), 1),
                _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$store.state.customer?.email), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_router_link, {
                to: `/`,
                class: "border-l-4 border-color-2 text-gray-600 block pl-3 pr-4 py-2 text-base font-medium"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("ホーム")
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: `/search`,
                class: "border-l-4 border-color-2 text-gray-600 hover:bg-gray-50 block pl-3 pr-4 py-2 text-base font-medium"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("検索")
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: `/me/profile`,
                class: "border-l-4 border-color-2 block px-4 py-2 text-base font-medium text-gray-500"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" プロフィール編集 ")
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: `/me/orders`,
                class: "border-l-4 border-color-2 block px-4 py-2 text-base font-medium text-gray-500"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 宇宙祈願・宇宙供養申込履歴 ")
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: `/me/decedents`,
                class: "border-l-4 border-color-2 block px-4 py-2 text-base font-medium text-gray-500"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 供養した故人 ")
                ]),
                _: 1
              }),
              _createElementVNode("a", {
                href: "javascript:void(0)",
                class: "border-l-4 border-color-2 block px-4 py-2 text-base font-medium text-gray-500",
                onClick: doSignout
              }, " ログアウト ")
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})